import { render, staticRenderFns } from "./RatingSetGrid.vue?vue&type=template&id=4327d1d4"
import script from "./RatingSetGrid.vue?vue&type=script&lang=js"
export * from "./RatingSetGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports